export default __webpack_public_path__ + "static/media/btn_bloquer.a7ece272.svg";